import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface INetworkStatus {
  networkStatus$: Observable<boolean>;
  isOnline: boolean;
}

export const NETWORK_STATUS = new InjectionToken<INetworkStatus>('NETWORK_STATUS');
